import { CSSProperties, ReactNode } from 'react'
import css from './keyValueTable.module.css'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'

interface IProps {
  values: { key: string | number; title: string | ReactNode; value: string | ReactNode | number }[]
  loading?: boolean

  itemStyle?: CSSProperties
}

const KeyValueTable = (props: IProps) => {
  if (props.loading) {
    return (
      <div style={{ height: '100px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ThreeDotsLoader inscription="Загружаем данные" />
      </div>
    )
  }

  if (!props.values.length) {
    return <EmptyPlaceholder inscription="Отсутствуют данные для отображения" />
  }

  return (
    <div className={css.wrapper}>
      {props.values.map((v) => (
        <div className={css.item} key={v.key} style={props.itemStyle}>
          <div className={css.itemCell}>
            {typeof v.title === 'string' ? <span className="text-nm">{v.title}</span> : v.title}
          </div>
          <div className={css.itemCell}>
            {typeof v.value === 'string' || typeof v.value === 'number' ? (
              <span className="text-nm">{v.value}</span>
            ) : (
              v.value
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default KeyValueTable
